/* components/App.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { resetLabels } from "~/stores/labels";
import { route } from "~/stores/router";
import Intro from "./Intro";
import Labels from "./labels/Labels";
import Tab from "./Tab";

function create_fragment(ctx) {
	let div1;
	let p0;
	let t1;
	let p1;
	let t4;
	let hr;
	let t5;
	let div0;
	let nav;
	let t6;
	let t7;
	let t8;
	let t9;
	let current;
	const tab0 = new Tab({ props: { name: "Intro", tabRoute: "/" } });

	const tab1 = new Tab({
			props: { name: "Labels", tabRoute: "/labels" }
		});

	const tab2 = new Tab({
			props: {
				name: "Conditions",
				tabRoute: "/conditions"
			}
		});

	const tab3 = new Tab({
			props: {
				name: "Generate Workflow/Config",
				tabRoute: "/generate"
			}
		});

	var switch_value = /*component*/ ctx[0];

	function switch_props(ctx) {
		return {};
	}

	if (switch_value) {
		var switch_instance = new switch_value(switch_props(ctx));
	}

	return {
		c() {
			div1 = element("div");
			p0 = element("p");
			p0.textContent = "Super Labeler Config Generator";
			t1 = space();
			p1 = element("p");

			p1.innerHTML = `
    Generate a config for the
    <a href="https://github.com/IvanFon/super-labeler-action">
      Super Labeler Github Action
    </a>`;

			t4 = space();
			hr = element("hr");
			t5 = space();
			div0 = element("div");
			nav = element("nav");
			create_component(tab0.$$.fragment);
			t6 = space();
			create_component(tab1.$$.fragment);
			t7 = space();
			create_component(tab2.$$.fragment);
			t8 = space();
			create_component(tab3.$$.fragment);
			t9 = space();
			if (switch_instance) create_component(switch_instance.$$.fragment);
			attr(p0, "class", "h1 text-center");
			attr(p1, "class", "h3 text-center");
			attr(nav, "class", "tabnav-tabs");
			attr(div0, "class", "tabnav");
			attr(div1, "class", "Box box-shadow-medium container-lg mt-6 p-3");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, p0);
			append(div1, t1);
			append(div1, p1);
			append(div1, t4);
			append(div1, hr);
			append(div1, t5);
			append(div1, div0);
			append(div0, nav);
			mount_component(tab0, nav, null);
			append(nav, t6);
			mount_component(tab1, nav, null);
			append(nav, t7);
			mount_component(tab2, nav, null);
			append(nav, t8);
			mount_component(tab3, nav, null);
			append(div1, t9);

			if (switch_instance) {
				mount_component(switch_instance, div1, null);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (switch_value !== (switch_value = /*component*/ ctx[0])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = new switch_value(switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, div1, null);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				0;
			}
		},
		i(local) {
			if (current) return;
			transition_in(tab0.$$.fragment, local);
			transition_in(tab1.$$.fragment, local);
			transition_in(tab2.$$.fragment, local);
			transition_in(tab3.$$.fragment, local);
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tab0.$$.fragment, local);
			transition_out(tab1.$$.fragment, local);
			transition_out(tab2.$$.fragment, local);
			transition_out(tab3.$$.fragment, local);
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(tab0);
			destroy_component(tab1);
			destroy_component(tab2);
			destroy_component(tab3);
			if (switch_instance) destroy_component(switch_instance);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $route;
	component_subscribe($$self, route, $$value => $$invalidate(1, $route = $$value));
	const ROUTES = { "/": Intro, "/labels": Labels };
	let component;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$route*/ 2) {
			$: $$invalidate(0, component = ROUTES[$route] || Intro);
		}
	};

	return [component];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;